import { debounce } from 'lodash';
import { useState, useEffect, useMemo } from 'react';

export enum Size {
  sm = 1,
  md = 2,
  lg = 3,
  xl = 4,
}

function getCurrentSize(): Size {
  const width = window.innerWidth;
  if (width < 480) {
    return Size.sm;
  }
  if (width < 1024) {
    return Size.md;
  }
  if (width < 1200) {
    return Size.lg;
  }
  return Size.xl;
}

export const useWindowSize = () => {
  const initialSize = useMemo(getCurrentSize, []);
  const [size, setSize] = useState<Size>(initialSize);

  useEffect(() => {
    const handleResize = debounce(() => {
      setSize(getCurrentSize());
    }, 400);

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return size;
};
